<template>
    <div class="row header d-flex align-items-center justify-content-between" :class="headerClass">
        <div class="col col-sm order-1 pr-0" v-if="title">
            <h1 class="content-title">{{ $t(title) }}</h1>
        </div>
        <div class="col-12 col-sm text-center order-3 order-sm-2 pt-2 pt-sm-0" v-if="showSearch">
            <div class="form-group has-search mb-0 flex-nowrap input-group">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="search"
                    class="form-control form-control-sm form-control-search"
                    @input="handleModelInput"
                    @keyup="onKeyUp"
                    v-model.trim="valueSearch"
                    :placeholder="$t(placeholderSearch)">
                      <div
                        class="input-group-append position-relative"
                        v-if="valueSearch"
                    >
                        <button
                            class="btn btn-default text-right min-w-auto px-2 py-0 d-flex align-items-center justify-content-center"
                            type="button"
                            @click="clearSearchValue"
                        >
                            <span class="d-flex align-items-center justify-content-center">
                                <i
                                    style="font-size: 1.1rem"
                                    class="fas fa-times-circle"
                                ></i>
                            </span>
                        </button>
                    </div>
            </div>
        </div>
        <div class="col col-sm order-2 order-sm-3 pl-0 d-flex justify-content-end" v-if="canConfig || canAdd || hasButtonsRightSlot">
            <router-link v-if="canConfig"
                data-toggle="tooltip-city"
                :title="$t(configTitle)"
                class="btn btn-main btn-rounded btn-sm my-0 min-w-auto"
                :class="[canAdd ? 'pr-3' : '']"
                :to="{ name: routeConfigName }">
                <i class="fas fa-cogs"></i>
            </router-link>
            <router-link v-if="canAdd"
                data-toggle="tooltip-city"
                :title="showAddTitle && addTitle ? null : $t(addTitle)"
                class="btn btn-main btn-rounded btn-sm min-w-auto my-0 mx-0 order-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline"
                :to="{ name: routeAddName, params: routeAddParams }">
                <i v-if="icon != ''" :class="icon"></i>
                <template v-if="showAddTitle">
                    &nbsp;<span>{{ $t(addTitle) }}</span>
                </template>
            </router-link>
            <slot name="buttons-right">
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ManageHeaderList',
        props: {
            title: {
                type: String,
                required: false,
            },
            showSearch: {
                type: Boolean,
                default: true,
            },
            placeholderSearch: {
                type: String,
                default: 'global.placeholder-search',
            },
            canAdd: {
                type: Boolean,
                default: false,
            },
            routeAddName: {
                type: String,
                default: '',
            },
            routeAddParams: {
                type: Object,
                default: () => {},
            },
            showAddTitle: {
                type: Boolean,
                default: true,
            },
            addTitle: {
                type: String,
                default: 'global.add',
            },
            value: {
                default: null,
            },
            headerClass: {
                type: String,
                default: 'mt-2 mb-3 mt-sm-0 mb-md-4',
            },
            icon: {
                type: String,
                default: '',
            },
            canConfig: {
                type: Boolean,
                default: false,
            },
            routeConfigName: {
                type: String,
                default: '',
            },
            configTitle: {
                type: String,
                default: 'global.config',
            },
        },
        data () {
          return {
            valueSearch: null,
          }
        },
        beforeMount () {
          this.copyValue(this.value)
        },
        computed: {
            hasButtonsRightSlot () {
                return !!this.$slots['buttons-right'];
            },
        },
        methods: {
            copyValue (value) {
                this.valueSearch = value;
            },
            handleModelInput (event) {
                this.$emit('input', event.target.value, event);
            },
            onKeyUp(evt){
                // this.$emit('search', evt.target.value, evt);
            },
             clearSearchValue(){
                 this.handleModelInput({ target: { value: '' } });
            },
        },
        watch: {
            value (newValue) {
                // This watch works from the code side of the 2-way-binding:
                this.copyValue(newValue)
            },
            valueSearch (newValue) {
                this.$emit('search', newValue);
            },
        },
    }
</script>

<style lang="scss" scoped>
.row.header {
    .content-title {
        margin-top: 0;
        margin-bottom: 0;
    }
}
input[type="search"] {
    &::-webkit-search-cancel-button {
        display: none;
    }
}
</style>